import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-recaptcha',
    templateUrl: './recaptcha.component.html',
    styleUrls: ['./recaptcha.component.scss'],
    standalone: false
})
export class RecaptchaComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
